import { render } from "./FeedItem.vue?vue&type=template&id=86970134&lang=true"
import script from "./FeedItem.vue?vue&type=script&lang=js"
export * from "./FeedItem.vue?vue&type=script&lang=js"
script.render = render

export default script